module.exports = __webpack_public_path__ + "assets/img/mask-group-3.862fefc2.png";